import { AxiosResponse } from 'axios';

import {
  Configuration,
  DefaultApi as HyliaApi,
} from '@peartherapeutics/hylia-api-client';
import { Config } from 'utils/config/config';
import { loadAuthToken } from 'utils/tokenStorage';
import { handleExpiredToken } from 'utils/session';

/**
 * Singleton to ensure there is a single instantiation of HyliaAPI
 */
export class HyliaApiClientInstance {
  private static instance: HyliaApi | null;

  private static unauthenticatedInstance: HyliaApi | null;

  public static get(): HyliaApi {
    if (!this.instance) {
      this.instance = new HyliaApi(
        new Configuration({
          apiKey: `JWT ${loadAuthToken()}`,
          basePath: Config.HYLIA_API_URL,
        }),
      );
    }
    return this.instance;
  }

  public static getUnauthenticatedInstance(): HyliaApi {
    this.unauthenticatedInstance = new HyliaApi(
      new Configuration({
        basePath: Config.HYLIA_API_URL,
      }),
    );
    return this.unauthenticatedInstance;
  }

  private static sendRequest<T>(request: any): Promise<AxiosResponse<T>> {
    return new Promise((resolve, reject) => {
      request
        .then((data: AxiosResponse<T>) => {
          resolve(data);
        })
        .catch((error: any) => {
          if (error.response?.status === 401) {
            handleExpiredToken();
          }
          reject(error);
        });
    });
  }

  public static getPatientSnapshotPdf(
    patientId: string,
    prescriptionId: string,
  ) {
    return HyliaApiClientInstance.sendRequest<object>(
      HyliaApiClientInstance.get().getPatientSnapshotPdf(
        patientId,
        prescriptionId,
        { responseType: 'blob' },
      ),
    );
  }

  public static reset(): void {
    this.instance = null;
  }
}
